export default __webpack_public_path__ + "static/media/inspection_dashboard.b628164c.svg";